import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Observable, withLatestFrom } from 'rxjs';
import { TestAgentOtp } from 'src/app/core/models';
import { CreateTestAgentOtp } from 'src/app/core/store/test-patients/test-patients.actions';
import { TestPatientsState } from 'src/app/core/store/test-patients/test-patients.state';
import { ApiStoreData } from 'src/app/core/store/utils';
import { asFormControl } from 'src/app/core/utils/common';
import { minExclusiveValidator, validateAllFormFields } from 'src/app/core/utils/validators';

@Component({
  selector: 'app-test-agent',
  templateUrl: './test-agent.component.html',
  styleUrls: ['./test-agent.component.scss'],
})
export class TestAgentComponent {
  @Select(TestPatientsState.createTestAgentOtpState) createTestAgentOtpState$!: Observable<
    ApiStoreData<TestAgentOtp | null>
  >;

  asFormControl = asFormControl;
  agentForm = new FormGroup({
    patientId: new FormControl(null, [Validators.required, minExclusiveValidator(0)]),
    agentToken: new FormControl(null, [Validators.required]),
  });

  showError: boolean = false;

  constructor(private store: Store, private router: Router) {}

  onSubmitAgentForm() {
    if (!this.agentForm.valid) {
      validateAllFormFields(this.agentForm);
      return;
    }

    this.showError = false;

    this.store
      .dispatch(new CreateTestAgentOtp(this.agentForm.value))
      .pipe(withLatestFrom(this.createTestAgentOtpState$))
      .subscribe(([_, createTestAgentOtpState]) => {
        if (createTestAgentOtpState.error) {
          this.showError = true;
          return;
        }

        this.router.navigate(['/agents'], { queryParams: { otp: createTestAgentOtpState.data?.otp } });
      });
  }
}
